<template>
  <div>

    <ed-modal
      :title="formData.id == 0 ? 'Nova Medição' : 'Editar Medição'"
      :modal="showFormEdit"
      :loadingSave="config.loading.save"
      :isModal="false"
      :onSave="this.salvar"
      width="98%"
    >
      <div
        slot="modal-content"
        v-loading="config.loading.content"
        class="ltcat-medicao"
      >

        <ed-form :model="formData" class="">
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
          >
            Informações Gerais
          </div>

          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left"
            label="Replicar Medição para os Seguintes GHE"
            v-model="formData.replicar"
            :items="config.list.replicar"
            multiple
          />
          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left"
            label="Fator de Risco"
            name="id_tab.id"
            v-model="formData.id_age"
            :items="config.list.id_age"
            @search="getFatorRisco"
            remote
            is-object
          />

          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left"
            label="Tabela Dinâmica"
            name="id_age.id"
            v-model="formData.id_tab"
            :items="config.list.id_tab"
            itemText="tabela_dinamica"
               is-object
          />

          <ed-input-text
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left"
            label="Nº de Amostragens Necessárias por Ponto"
            type="number"
            v-model="formData.amostragem"
          />

          <ed-input-date
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left"
            label="Data Medição"
            v-model="formData.data_medicao"
          />

          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
          >
            Equipamentos
          </div>

        
         <table width="100%" border="0">
           <thead>
             <tr>
               <td colspan="8">
                 <ed-alert>
                    <div slot="description">
                       <a href="http://caepi.mte.gov.br/internet/ConsultaCAInternet.aspx" target="_blank">
                          Clique aqui para consultar a lista de CA
                        </a>
                    </div>
                  
                 </ed-alert>
               </td>
             </tr>
            <tr>
              <td colspan="7">
                  <ed-input-auto-complete
                      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0 text-left "
                      label="Pesquisar Equipamento"
                      placeholder="Digite o nome do EPI"
                      v-model="formData.epi"
                      :items="config.list.epi"
                      :loading="config.loading.epi"
                      @search="getEquipamento"
                      @input="addEPI"
                      itemText="epi"
                      maxLenght="10"
                      clearable
                      is-object
                  />
              </td>
              <!-- <td width="100" valign="bottom">
                  <ed-button
                    icon="fa fa-plus-circle"
                    type="text"
                    @click="addEPI"
                    value="Adicionar EPI"
                  />
              </td> -->
            </tr>
          </thead>
           <tbody v-if="formData.equipamentos && formData.equipamentos.length">
             <tr>
               <td colspan="7" style="margin-top:2px">&nbsp;</td>
             </tr>
              <tr>
                <td style="background:#cccccc;border-top:solid 1px #cccccc"><b>EPI</b></td>
                <td style="background:#cccccc">
                  <b>
                    Med. Protecao 
                    <i class="fa fa-info-circle" title="Foi tentada a implementação de medidas de proteção coletiva, de caráter administrativo ou de organização, optando-se pelo EPI por inviabilidade técnica, insuficiência ou interinidade, ou ainda em caráter complementar ou emergencial?"></i>
                  </b>
                </td>
                <td style="background:#cccccc;border-top:solid 1px #cccccc">
                  <b>
                    Cond. Funcionamento 
                    <i class="fa fa-info-circle" title="Foram observadas as condições de funcionamento do EPI ao longo do tempo, conforme especificação técnica do fabricante nacional ou importador, ajustadas às condições de campo?"></i>
                  </b>
                </td>
                <td style="background:#cccccc;border-top:solid 1px #cccccc">
                  <b>
                    Uso Ininterrupto 
                    <i class="fa fa-info-circle" title="Foi observado o uso ininterrupto do EPI ao longo do tempo, conforme especificação técnica do fabricante nacional ou importador, ajustadas às condições de campo?"></i>
                  </b>
                </td>
                <td style="background:#cccccc;border-top:solid 1px #cccccc">
                  <b>
                    Validade 
                    <i class="fa fa-info-circle" title="Foi observado o prazo de validade do CA no momento da compra do EPI?"></i>
                  </b>
                </td>
                <td style="background:#cccccc;border-top:solid 1px #cccccc">
                  <b>
                    Troca 
                    <i class="fa fa-info-circle" title="É observada a periodicidade de troca definida pelo fabricante nacional ou importador e/ou programas ambientais, comprovada mediante recibo assinado pelo usuário em época própria?"></i>
                  </b>
                </td>
                <td style="background:#cccccc;border-top:solid 1px #cccccc" colspan="2">
                  <b>
                    Higienização
                    <i class="fa fa-info-circle" title="É observada a higienização conforme orientação do fabricante nacional ou importador?"></i>
                  </b>
                </td>
              </tr>
              <tr v-for="(equipamento,index) in formData.equipamentos" :key="index">
                <td style="border-top:solid 1px #cccccc">
                  {{equipamento.epi.nome}}
                  
                  <span v-if="equipamento.epi.ca">
                    <br><b>CA:</b> {{equipamento.epi.ca}}
                  </span>

                  <span v-if="equipamento.epi.categoria">
                    <br><b>Categoria:</b> {{equipamento.epi.categoria.nome}}
                  </span>
                  </td>
                <td style="border-top:solid 1px #cccccc">
                    <ed-input-switch
                      name="medProtecao"
                      v-model="equipamento.medProtecao"
                    />
                </td>
                <td style="border-top:solid 1px #cccccc">
                    <ed-input-switch
                      name="condFuncto"
                      v-model="equipamento.condFuncto"
                    />
                </td>
                <td style="border-top:solid 1px #cccccc">
                    <ed-input-switch
                      name="usoInint"
                      v-model="equipamento.usoInint"
                    />
                </td>
                <td style="border-top:solid 1px #cccccc">
                    <ed-input-switch
                      name="przValid"
                      v-model="equipamento.przValid"
                    />
                </td>
                <td style="border-top:solid 1px #cccccc">
                  <ed-input-switch
                      name="periodicTroca"
                      v-model="equipamento.periodicTroca"
                    />
                </td>
                <td style="border-top:solid 1px #cccccc">
                  <ed-input-switch
                      name="higienizacao"
                      v-model="equipamento.higienizacao"
                    />
                </td>
                <td style="border-top:solid 1px #cccccc">
                  <ed-button
                    icon="fa fa-times"
                    type="button"
                    @click="removeEPI(index)"
                  />
                </td>
              </tr>
           </tbody>
         </table>

          <!-- <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
          >
            Informações do eSocial
          </div>

          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-left"
            info="O empregador implementa medidas de proteção coletiva (EPC) para eliminar ou reduzir a exposição dos trabalhadores ao agente nocivo?"
            label="Utilização EPC"
            v-model="formData.utilizEPC"
            :items="this.config.list.utilizEPC"
          />

          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-left"
            info="Os EPCs são eficazes na neutralização do risco ao trabalhador?"
            label="EPC Eficaz"
            v-model="formData.eficEpc"
            :items="this.config.list.periculosidade"
          />

          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-left"
            info="Utilização de EPI."
            label="Utilização EPI"
            v-model="formData.utilizEPI"
            :items="this.config.list.utilizEPC"
          />

           <ed-input-select
            class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-left"
            info="Os EPIs são eficazes na neutralização do risco ao trabalhador?"
            label="EPI Eficaz"
            v-model="formData.eficEpi"
            :items="this.config.list.periculosidade"
          /> -->

          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
          >
            INFORMAÇÕES DA MEDIÇÃO
          </div>

          <div slot="form-footer" v-loading="config.loading.lancamentos">
            <div class="" v-if="formData.id_tab">
              <div
                class="col-12 text-left p-0 mb-2"
                v-for="(coluna, i) in config.list.lancamentos"
                :key="i"
              >
                <div
                  v-if="showCategoria(coluna, i)"
                  class=""
                  :style="'font-weight: bold;'"
                >
                  <span v-if="coluna.tabela_categoria">
                    {{ coluna.tabela_categoria.nome }}
                  </span>
                  <span v-else-if="!coluna.tabela_categoria">
                    {{ coluna.nome }}
                  </span>

                  <ed-button
                    v-if="coluna.tipo_campo.id == 217"
                    icon="fa fa-plus-circle"
                    type="text"
                    @click="onInserirLinha(coluna, i)"
                    value="Inserir Nova Linha"
                  />
                </div>

                <!--COLUNAS-->
                <div :class="'col-12 p-0 mt-1 mb-1'">
                  <el-input
                    v-if="
                      coluna.tipo_campo.id == 208 || coluna.tipo_campo.id == 216
                    "
                    v-model="coluna.valor"
                    v-mask="coluna.mascara ? coluna.mascara : ''"
                    :type="coluna.tipo_campo.valor"
                  >
                    <template slot="append" v-if="coluna.unidade">{{
                      coluna.unidade
                    }}</template>
                  </el-input>
                  <el-input
                    v-if="coluna.tipo_campo.id == 215"
                    v-model="coluna.valor"
                    v-mask="'money'"
                    :type="coluna.tipo_campo.valor"
                  >
                    <template slot="append" v-if="coluna.unidade">{{
                      coluna.unidade
                    }}</template>
                  </el-input>

                  <el-input-number
                    v-if="coluna.tipo_campo.id == 209"
                    v-model="coluna.valor"
                  />

                  <span v-if="coluna.tipo_campo.id == 210">
                    {{ coluna.nome }}
                  </span>

                  <el-select
                    v-if="coluna.tipo_campo.id == 210"
                    v-model="coluna.valor"
                    :clearable="true"
                    placeholder="Selecione"
                  >
                    <el-option
                      v-for="item in coluna.tabela_valores"
                      :key="item.id"
                      :label="item.nome"
                      :value="item.id"
                    />
                  </el-select>
                </div>

                <!--COLUNAS VALORES-->
                <div
                  class="row"
                  v-if="
                    coluna.tabela_valores.length > 0 &&
                    coluna.tipo_campo.id != 210
                  "
                >
                  <div
                    :class="
                      'col-' +
                      12 / coluna.tabela_valores.length +
                      ' text-left mb-2'
                    "
                    v-for="(coluna_val, j) in coluna.tabela_valores"
                    :key="i + j"
                  >
                    {{ coluna_val.nome }}
                    <el-input
                      v-if="
                        coluna.tipo_campo.id != 217 &&
                        coluna_val.tipo_campo &&
                        (coluna_val.tipo_campo.id == 208 ||
                          coluna_val.tipo_campo.id == 216)
                      "
                      v-model="coluna_val.valor"
                      :type="
                        coluna_val.tipo_campo
                          ? coluna_val.tipo_campo.valor
                          : 'text'
                      "
                    >
                      <template slot="append" v-if="coluna_val.unidade">{{
                        coluna_val.unidade
                      }}</template>
                    </el-input>

                    <el-input
                      v-else-if="
                        coluna.tipo_campo.id != 217 &&
                        coluna_val.tipo_campo &&
                        coluna_val.tipo_campo.id == 215
                      "
                      v-model="coluna_val.valor"
                      v-mask="'money'"
                      type="text"
                    >
                      <template slot="append" v-if="coluna_val.unidade">{{
                        coluna_val.unidade
                      }}</template>
                    </el-input>

                    <el-input-number
                      v-else-if="
                        coluna.tipo_campo.id != 217 &&
                        coluna_val.tipo_campo &&
                        coluna_val.tipo_campo.id == 209
                      "
                      v-model="coluna_val.valor"
                    />

                    <!--COLUNAS VALORES TABELA-->
                    <div
                      :class="'col-12 text-left p-0 mt-2'"
                      v-for="(coluna_val_lin, k) in coluna_val.linhas"
                      :key="i + j + k"
                    >
                      <span v-if="j == 0 && k > 0">
                        <el-link
                          type="danger"
                          @click="onDeleteLinha(coluna, k)"
                        >
                          <i class="fa fa-trash" />
                          Remover Linha
                        </el-link>
                      </span>
                      <span v-else-if="k > 0">&nbsp;</span>

                      <el-input
                        v-if="
                          coluna_val_lin.tipo_campo &&
                          (coluna_val_lin.tipo_campo.id == 208 ||
                            coluna_val_lin.tipo_campo.id == 216)
                        "
                        v-model="coluna_val_lin.valor"
                        :type="
                          coluna_val_lin.tipo_campo
                            ? coluna_val_lin.tipo_campo.valor
                            : 'text'
                        "
                      >
                        <template slot="append" v-if="coluna_val_lin.unidade">{{
                          coluna_val_lin.unidade
                        }}</template>
                      </el-input>

                      <el-input
                        v-else-if="
                          coluna_val_lin.tipo_campo &&
                          coluna_val_lin.tipo_campo.id == 215
                        "
                        v-model="coluna_val_lin.valor"
                        v-mask="'money'"
                        type="text"
                      >
                        <template slot="append" v-if="coluna_val_lin.unidade">{{
                          coluna_val_lin.unidade
                        }}</template>
                      </el-input>

                      <el-input-number
                        v-else-if="
                          coluna_val_lin.tipo_campo &&
                          coluna_val_lin.tipo_campo.id == 209
                        "
                        v-model="coluna_val_lin.valor"
                      />
                    </div>
                  </div>
                </div>

                <div
                  v-if="
                    response.status == 400 &&
                    response.options.data[0] &&
                    response.options.data[0][coluna.id]
                  "
                  class="mt-1"
                  style="color: #e66666; font-size: 9pt"
                >
                  {{ response.options.data[0][coluna.id] }}
                </div>
              </div>
            </div>
          </div>
        </ed-form>


        <ed-alert
          v-if="
            !config.loading.content &&
            !config.loading.lancamentos &&
            (!formData.id_age || !formData.id_tab)
          "
          type="warning"
          title="Selecione todos os campos obrigatórios"
        />
      </div>
    </ed-modal>

    <ed-table
      registerName="Inserir Nova Medição"
      :onRegister="onRegister"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :onSearch="getLtcatRisco"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
    />
  </div>
</template>

<script>
import EdTable from "common/table";
import EdModal from "common/modal";
import EdButton from "common/button";
import Rest from "common/rest";
import {
  EdForm,
  EdAlert,
  EdInputText,
  EdInputDate,
  EdInputAutoComplete,
  EdInputSelect,
  EdInputSelectTipo,
  EdInputSwitch,
} from "template";

export default {
  name: "ltcat.ghe.medicao",
  components: { 
    EdTable, 
    EdAlert, 
    EdModal, 
    EdForm, 
    EdButton,
    EdInputText,
    EdInputDate,
    EdInputAutoComplete,
    EdInputSelect,
    EdInputSelectTipo,
    EdInputSwitch,
  },
  mixins: [Rest],
  props: {
    parent: {
      type: Object,
      default: null,
    },
    ltcat: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "parent.formData.id"() {
      this.getLtcatRisco();
      this.getGhe();
    },
    "$store.state.ltcat.data.id"() {
      this.getGhe();
    },
    "formData.id_age"() {
      if (this.formData.id_age && this.formData.id_age.tabela) {
        this.formData.id_tab = this.formData.id_age.tabela;
      } else if (this.formData.id == 0) {
        this.getTabelaDinamicaColuna();
      }
    },
    "formData.id_tab"() {
      this.getTabelaDinamicaColuna();
    },
  },
  data() {
    return {
      config: {
        loading: {
          save: false,
          content: false,
          id_age: false,
          id_tab: false,
          lancamentos: false,
          equipamentos: false,
          replicar: false,
          aposentadoria_especial: false,
          periculosidade:false,
          insalubridade: false,
          epi:false,
        },
        list: {
          id_age: [],
          id_tab: [],
          lancamentos: [],
          equipamentos: [],
          replicar: [],
          aposentadoria_especial: [],
          periculosidade:[],
          insalubridade:[],
          epi:[],
          utilizEPC:[
            {id:0,nome:'Não se aplica'},
            {id:1,nome:'Não implementa'},
            {id:2,nome:'Implementa'},
          ]
        },
      },
      pagination: {},
      response: {},
      formData: {
        id: 0,
        id_ghe: null,
        id_age: null,
        id_tab: null,
        usuario: null,
        updated_at: null,
        epi:null,
        aposentadoria_especial: 0,
        periculosidade:0,
        insalubridade:0,
        obs: null,
        data_medicao: null,
        replicar: [],
        replicar_subs: 0,
        amostragem: 1,
        fator_riscos: [],
        equipamentos: [],
      },
      formItems: [],
      tableHead: [
        {
          key: "risco",
          sortable: true,
          label: "Fator de Risco",
        },
        {
          key: "amostragem",
          sortable: true,
          label: "Nº Amostragem",
        },
        {
          key: "data_medicao",
          sortable: true,
          label: "Data Medição",
        },
        {
          key: "obs",
          sortable: true,
          label: "Observações",
        },
        {
          key: "updated_at",
          width: "180px",
          sortable: true,
          show_user: true,
          label: "Atualização",
        },
      ],
      tableData: [],
      loadingTable: true,
      showFormEdit: false,
      showFormEquipamento: false,
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {},

  mounted() {
    this.getLtcatRisco();
    this.getFatorRisco();
    this.getTabelaDinamica();
    this.getEquipamento();
    this.getGhe();
    this.getAposentadoriaEspecial();
    this.getPericulosidade();
    this.getInsalubridade();
  },

  methods: {
    getAposentadoriaEspecial(){
      this.config.list.aposentadoria_especial =  [
        {id:'0',nome:'Não'},
        {id:'1',nome:'Sim'}
      ];
    },

    getPericulosidade(){
      this.config.list.periculosidade =  [
        {id:0,nome:'Não'},
        {id:1,nome:'Sim'}
      ];
    },

    getInsalubridade(){
       this.config.list.insalubridade =  [
        {id:0,nome:'Não'},
        {id:1,nome:'Sim'}
      ];
    },
    
    onRegister() {
      this.formData = {
        id: 0,
        id_ghe: this.parent.formData.id,
        id_age: null,
        id_tab: null,
        usuario: null,
        updated_at: null,
        epi:null,
        aposentadoria_especial: 0,
        periculosidade:0,
        insalubridade:0,
        obs: null,
        data_medicao: this.toDate(),
        lancamentos: [],
        equipamentos: [],
        replicar: [],
        replicar_subs: 0,
        amostragem: 1,
        utilizEPC:0,
        utilizEPI:0,
        eficEpi:1,
        eficEpc:1
      };
      this.showFormEdit = !this.showFormEdit;
    },

    removeEPI(index){
      this.formData.equipamentos.splice(index,1)
    },

    addEPI(){

      if(!this.formData.equipamentos){
        this.formData.equipamentos = [];
      }

      if(this.formData.epi && this.formData.equipamentos.findIndex(x => x.id_epi == this.formData.epi.id) == -1){

        

        let equipamento = {
          id_ghe_med : this.formData.id,
          id_epi: this.formData.epi.id,
          epi: this.formData.epi,
          medProtecao:1,
          condFuncto:1,
          usoInint:1,
          przValid:1,
          periodicTroca:1,
          higienizacao:1,
        }

        this.formData.equipamentos.push(equipamento)

      }

      
      this.formData.epi = null;

      console.log('formData',this.formData)
    },

    onEdit(data) {
      this.$root.$loading.set(true, "Carregando medição");

      this.config.loading.lancamentos = true;
      this.showFormEdit = !this.showFormEdit;
      this.config.list.id_age = [];
      this.config.list.equipamentos = [];
      this.response = {};

      this.get(
        "/ltcat/ghe/medicao/" + this.parent.formData.id + "/" + data.id
      ).then((result) => {
        result = result[0];

        this.response = result;

        if (result.status == 200) {
          this.formData = {
            id: result.data.id,
            id_ghe: this.parent.formData.id,
            id_age: result.data.fator_risco,
            id_tab: result.data.tabela,
            usuario: result.data.usuario,
            tabela: result.data.tabela,
            updated_at: result.data.updated_at,
            obs: result.data.obs,
            data_medicao: result.data.data_medicao,
            lancamentos: result.data.lancamentos,
            amostragem: result.data.amostragem,
            epi:null,
            aposentadoria_especial: (!result.data.aposentadoria_especial ? 0 : parseInt(result.data.aposentadoria_especial)),
            periculosidade:(!result.data.periculosidade ? 0 : parseInt(result.data.periculosidade)),
            insalubridade:(!result.data.insalubridade ? 0 : parseInt(result.data.insalubridade)),
            utilizEPC:(!result.data.utilizEPC ? 0 : parseInt(result.data.utilizEPC)),
            utilizEPI:(!result.data.utilizEPI ? 0 : parseInt(result.data.utilizEPI)),
            eficEpi:(!result.data.eficEpi ? 0 : parseInt(result.data.eficEpi)),
            eficEpc:(!result.data.eficEpc ? 0 : parseInt(result.data.eficEpc)),
            equipamentos: result.data.equipamentos,
            replicar: [],
            replicar_subs: 0,
          };

          this.config.list.id_age.push(data.fator_risco);
        }

        this.config.loading.lancamentos = false;
        this.$root.$loading.set(false);
      });
    },

    onInserirLinha(coluna, i) {
      for (let i = 0; i < coluna.tabela_valores.length; i++) {
        var element = coluna.tabela_valores[i];

        element.linhas.push({
          id: element.id,
          id_tab_col: element.id_tab_col,
          id_tipo_campo: element.id_tipo_campo,
          tipo_campo: element.tipo_campo,
          nome: null,
          ordem: element.linhas.length + 1,
          unidade: element.unidade,
          padrao: element.padrao,
          ativo: element.ativo,
        });
      }
    },

    onDeleteLinha(coluna, index) {
      if (index == 0) return;

      for (let i = 0; i < coluna.tabela_valores.length; i++) {
        var element = coluna.tabela_valores[i];

        if (element.linhas.length > 1) {
          element.linhas.splice(index, 1);
        }
      }
    },

    onInserirEquipamento() {
      this.showFormEquipamento = !this.showFormEquipamento;
    },

    onDelete(data) {
      var self = this;

      this.$confirm(
        "O sistema vai excluir " +
          data.length +
          " registro(s). Deseja prosseguir?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        self.loadingEditAll = true;
        self.loadingTable = true;

        this.post(
          "/ltcat/ghe/medicao/" + this.parent.formData.id + "/deletar",
          { ids: data }
        ).then((result) => {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcatRisco();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    getGhe: function (_search) {
      if (!this.$store.state.ltcat.data) return;

      this.config.loading.replicar = true;
      this.config.list.replicar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search,
      }).then((result) => {
        result = result[0];
        this.config.loading.replicar = false;

        if (result.status == 200) {
          var data = result.data.data;

          for (let i = 0; i < data.length; i++) {
            const element = data[i];
            if (element.id != this.parent.formData.id) {
              element.nome = element.ghe+' ('+element.descricao+')'
              this.config.list.replicar.push(element);
            }
          }
        }
      });
    },

    getEquipamento: function (_search) {
      this.config.loading.epi = true;
      this.config.list.epi = [];

      this.get("epi", { search: _search }).then((result) => {
        result = result[0];
        this.config.loading.epi = false;

        if (result.status == 200) {
          this.config.list.epi = result.data.data;
        }
      });
    },

    getFatorRisco(_search) {

      console.log('asdf',_search)
      this.config.loading.id_age = true;
      this.config.list.id_age = [];

      this.get("fator-risco", { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.id_age = false;

        if (result.status == 200) {
          this.config.list.id_age = result.data.data;
        }
      });
    },

    getTabelaDinamica(_search) {
      this.config.loading.id_tab = true;
      this.config.list.id_tab = [];

      this.get("/ltcat/tabela-dinamica", { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.id_tab = false;

        if (result.status == 200) {
          this.config.list.id_tab = result.data.data;
        }
      });
    },

    getTabelaDinamicaColuna() {
      if (!this.formData.id_tab) return;

      this.config.loading.lancamentos = true;
      this.config.list.lancamentos = [];
      this.response = {};
      var filter = {
        id_ghe_med: this.formData.id,
      };

      this.get("/ltcat/tabela-dinamica/coluna/" + this.formData.id_tab.id, {
        filter: filter,
      }).then((result) => {
        result = result[0];
        this.response = result;

        this.config.loading.lancamentos = false;

        if (result.status == 200) {
          var data = result.data.data,
            coluna = null,
            tabela_valor = null,
            lancamento = null,
            item = null;

          for (let i = 0; i < data.length; i++) {
            coluna = data[i];
            // coluna.valor = null;

            // item = this.arrFindByField(this.formData.lancamentos,'id_tab_col',coluna.id);
            // if(item){
            // 	coluna.valor = item.valor;
            // }

            //VARREGAR CONTEUDO DO FATOR DE RISCO VINCULADO, CASO O VALOR DO LTCAT NÃO FOI ALTERADO PELO USUÁRIO
            if (!coluna.valor && this.formData.id_age && coluna.tipo_vinculo) {
              coluna.valor = this.formData.id_age[coluna.tipo_vinculo.valor];
            }

            //VALORES
            for (let j = 0; j < coluna.tabela_valores.length; j++) {
              tabela_valor = coluna.tabela_valores[j];
              // tabela_valor.valor = null;

              // for (let k = 0; k < this.formData.lancamentos.length; k++) {
              // 	lancamento = this.formData.lancamentos[k];

              // 	item = this.arrFindByField(lancamento.valores,'id_tab_col_val',tabela_valor.id);
              // 	if(item){
              // 		tabela_valor.valor = item.valor;
              // 	}

              // }
            }

            this.config.list.lancamentos.push(coluna);
          }

          data = null;
          coluna = null;
          tabela_valor = null;
          lancamento = null;
          item = null;
        }
      });
    },

    getLtcatRisco(_search, _page, _pagination) {
      this.loadingTable = true;
      this.response = {};

      this.get("/ltcat/ghe/medicao/" + this.parent.formData.id, {
        search: _search,
        page: _page,
        pagination: _pagination,
      }).then((result) => {
        result = result[0];
        this.response = result;
        this.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
            tableData = [],
            self = this,
            pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var item = {
              data_medicao: data[i].data_medicao
                ? this.toDate(data[i].data_medicao, true)
                : "---",
              obs: data[i].obs ? data[i].obs : "---",
              risco: data[i].fator_risco.nome,
              amostragem: data[i].amostragem,
              updated_at: this.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !this.validarPermissao(567),
                disable_edit: !this.validarPermissao(567),
              },
              buttons: [],
            };
            tableData.push(item);
          }

          this.pagination = pagination;
          this.tableData = tableData;
        }
      });
    },

    showCategoria(coluna, i) {
      var tabela_categoria = coluna.tabela_categoria,
        coluna_anterior = this.config.list.lancamentos[i - 1];

      if (!tabela_categoria || !coluna_anterior) return true;
      else if (coluna_anterior && !coluna_anterior.tabela_categoria)
        return true;
      else if (
        coluna.tabela_categoria.id != coluna_anterior.tabela_categoria.id
      )
        return true;
      else return false;
    },

    salvar() {
      this.config.loading.save = true;
      this.response = {};

      this.formData.lancamentos = Object.assign(
        {},
        this.config.list.lancamentos
      );

      this.$root.$request.post(
        "/ltcat/ghe/medicao/" + this.parent.formData.id + "/editar",
        this.formData
      ).then((result) => {
        //result = result[0];

        this.config.loading.save = false;
        this.response = result;
        
        if (result.status == 200) {
          this.edMsg("Dados atualizados");
          this.showFormEdit = !this.showFormEdit;
          this.getLtcatRisco();
        }
      });
    },
  },
};
</script>

<style>
.el-checkbox__label {
  /*display: none  !important;*/
}
.ltcat-medicao .el-radio__label {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// medicao.vue?d94b0062